import React from 'react';
import connectorUpwards from '../../assets/images/connector-upwards.svg'; 
import connectorDownwards from '../../assets/images/connector-downwards.svg';


const OurMilestones = () => {
  return ( 
    <div className="our-milestones">
      <p className="font-weight-extrabold fs-18 text-black">OUR MILESTONES</p>
      <div className="our-milestones-desktop">
        <div className="milestones">
          <div className="row">
            <div className="col-md-9">
              <p className="fs-36 text-primary font-weight-semibold">Growth rate of 180%<br></br> between 2015 and 2018</p>
              <p className="fs-14 text-gray">Ranked in Deloitte’s Technology Fast 500™ for<br></br> five consecutive years now</p>
            </div>
            <div className="col-md-3">
              <p className="fs-100 font-weight-thin text-light-gray">2019</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorDownwards} alt="Connector" width="70%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
            <p className="fs-100 font-weight-thin text-light-gray">2018</p>
            </div>
            <div className="col-md-5">
              <p className="fs-36 text-primary font-weight-semibold">Product Launch</p>
              <p className="fs-14 text-gray">Smart Recorder-4 Release</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorUpwards} alt="Connector" width="70%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              <p className="fs-36 text-primary font-weight-semibold">Technology<br></br>Enhancements</p>
              <p className="fs-14 text-gray">SmartiQ Product Launch.<br></br>E-Learning Module for customer education.</p>
            </div>
            <div className="col-md-3">
              <p className="fs-100 font-weight-thin text-light-gray">2017</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorDownwards} alt="Connector" width="70%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
            <p className="fs-100 font-weight-thin text-light-gray">2016</p>
            </div>
            <div className="col-md-5">
              <p className="fs-36 text-primary font-weight-semibold">Increase in<br></br>Employee Count</p>
              <p className="fs-14 text-gray">Grown to 450 employees worldwide.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorUpwards} alt="Connector" width="70%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              <p className="fs-36 text-primary font-weight-semibold">Recognized</p>
              <p className="fs-14 text-gray">Listed second time in Deloitte's<br></br>Technology Fast 500 Companies.</p>
            </div>
            <div className="col-md-3">
              <p className="fs-100 font-weight-thin text-light-gray">2015</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorDownwards} alt="Connector" width="70%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
            <p className="fs-100 font-weight-thin text-light-gray">2014</p>
            </div>
            <div className="col-md-5">
              <p className="fs-36 text-primary font-weight-semibold">Partnered<br></br>with WABCO</p>
              <p className="fs-14 text-gray">To roll out a performance management<br></br> system called Proview.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorUpwards} alt="Connector" width="70%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              <p className="fs-36 text-primary font-weight-semibold">Integration</p>
              <p className="fs-14 text-gray">Between Video based platform and Active<br></br> Safety Systems. Top 100 North America<br></br> Tech Startup by Red Herring.</p>
            </div>
            <div className="col-md-3">
              <p className="fs-100 font-weight-thin text-light-gray">2013</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorDownwards} alt="Connector" width="70%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
            <p className="fs-100 font-weight-thin text-light-gray">2012</p>
            </div>
            <div className="col-md-5">
              <p className="fs-36 text-primary font-weight-semibold">New Leader<br></br>onboard</p>
              <p className="fs-14 text-gray">Announced Mr. Steve Mitgang<br></br> as our new CEO.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={connectorUpwards} alt="Connector" width="70%" />
            </div>
          </div>
        </div>
      </div>
      <div className="our-milestones-mobile">
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2019</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">Growth rate of 180% between 2015 and 2018</p>
          <p className="fs-12 text-gray">Ranked in Deloitte’s Technology Fast 500™ for five consecutive years now</p>
        </div>
      </div>
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2018</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">Product Launch</p>
          <p className="fs-12 text-gray">Smart Recorder-4 Release</p>
        </div>
      </div>
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2017</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">Technology Enhancements</p>
          <p className="fs-12 text-gray">SmartiQ Product Launch. E-Learning Module for customer education.</p>
        </div>
      </div>
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2016</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">Increase in Employee Count</p>
          <p className="fs-12 text-gray">Grown to 450 employees worldwide.</p>
        </div>
      </div>
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2015</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">Recognized</p>
          <p className="fs-12 text-gray">Listed second time in Deloitte's Technology Fast 500 Companies.</p>
        </div>
      </div>
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2014</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">Partnered with WABCO</p>
          <p className="fs-12 text-gray">To roll out a performance management system called Proview.</p>
        </div>
      </div>
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2013</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">Integration</p>
          <p className="fs-12 text-gray">Between Video based platform & Active safety Systems. Top 100 North America Tech Startup by Red Herring.</p>
        </div>
      </div>
      <div className="d-flex mt-5">
        <p className="text-light-gray fs-18">2012</p>
        <div className="ml-4">
          <p className="fs-14 text-primary">New Leader onboard</p>
          <p className="fs-12 text-gray">Announced Mr. Steve Mitgang as our new CEO.</p>
        </div>
      </div>
    </div>
    </div>
   );
}
 
export default OurMilestones;